/* Global value object */
export const GlobalValues = {
    // Global configuration
    appName: "Intel Building",
    appNameShort: "IB",

    // API Keys
    googleMapsApiKey: "AIzaSyAeYsBx_MLIVrl7pgV2mVuw-N5VrN1N344",

    // Role constants
    superAdministratorRole: {
        id: 1,
        name: "Super Administrator"
    },
    operationsAdministratorRole: {
        id: 2,
        name: "Operations Administrator"
    },
    financeAdministratorRole: {
        id: 3,
        name: "Finance Administrator"
    },
    purchaseAdministratorRole: {
        id: 4,
        name: "Purchase Administrator"
    },
    projectManagerRole: {
        id: 5,
        name: "Project Manager"
    },
    organizationAdministratorRole: {
        id: 6,
        name: "Organization Administrator"
    },
    supervisorRole: {
        id: 7,
        name: "Supervisor"
    },
    employeeRole: {
        id: 8,
        name: "Employee"
    },
    customerAdministratorRole: {
        id: 9,
        name: "Customer Administrator"
    },
    customerEndUserRole: {
        id: 10,
        name: "Customer End User"
    },
    driverRole: {
        id: 11,
        name: "Driver"
    },

    // Organization type constants
    superAdministrationType: {
        id: 1,
        name: "Super Administration"
    },
    specialOrganizationType: {
        id: 2,
        name: "Special Organization"
    },
    organizationType: {
        id: 3,
        name: "Organization"
    },
    customerType: {
        id: 4,
        name: "Customer"
    },

    // Checklist item type constants
    booleanChecklistItemType: "BOOLEAN-RESPONSE",
    freeResponseChecklistItemType: "FREE-RESPONSE",

    // Base URLs
    // dashboardBaseUrl: "http://localhost:3000/",
    // apiBaseUrl: "http://192.168.25.45:8000/api/",

    // dashboardBaseUrl: "https://demo-app.intellbuilding.com/",
    // apiBaseUrl: "https://demo-api.intellbuilding.com/api/",

    // dashboardBaseUrl: "https://app.intellbuilding.com/",
    // apiBaseUrl: "https://api.intellbuilding.com/api/",

    dashboardBaseUrl: "https://kas-web-app.pleximus.co.in/",
    apiBaseUrl: "https://kas-apis-intelbuilding.pleximus.co.in/api/",
    //apiBaseUrl: "http://localhost:8000/api/",

    // Authentication URLs
    loginUrl: "users/custom-login/",
    logoutUrl: "users/custom-logout/",

    // Organization URLs
    organizationCreateUrl: "organization/",
    organizationListUrl: "organization/list/",
    organizationListFilterUrl: "organization/list-filter/",

    // Service URLs
    serviceCreateUrl: "service/",
    serviceListUrl: "service/list/",
    serviceListFilterUrl: "service/list-filter/",

    // Employee Category URLs
    employeeCategoryCreateUrl: "employeecategory/",
    employeeCategoryListUrl: "employeecategory/list/",
    employeeCategoryListFilterUrl: "employeecategory/list-filter/",

    // Checklist Category URLs
    checklistCategoryCreateUrl: "checklist/checklist-category/",
    checklistCategoryListUrl: "checklist/checklist-category/list/",
    checklistCategoryListFilterUrl: "checklist/checklist-category/list-filter/",

    // Checklist Item URLs
    checklistItemCreateUrl: "checklist/checklist-item/",
    checklistItemListUrl: "checklist/checklist-item/list/",
    checklistItemListFilterUrl: "checklist/checklist-item/list-filter/",

    // Project URLs
    projectCreateUrl: "project/",
    projectListUrl: "project/list/",
    projectListFilterUrl: "project/list-filter/",

    // Zone URLs
    zoneCreateUrl: "zone/",
    zoneListUrl: "zone/list/",
    zoneListFilterUrl: "zone/list-filter/",

    // Service Provider Type URLs
    serviceProviderTypeCreateUrl: "serviceprovider/service-provider-type/",
    serviceProviderTypeListUrl: "serviceprovider/list-service-provider-type/",
    serviceProviderTypeListFilterUrl: "serviceprovider/list-service-provider-type-filter/",

    // Service Provider URLs
    serviceProviderCreateUrl: "serviceprovider/",
    serviceProviderListUrl: "serviceprovider/list/",
    serviceProviderListFilterUrl: "serviceprovider/list-filter/",

    // User URLs
    userCreateUrl: "users/",
    userListUrl: "users/list/",
    userListFilterUrl: "users/list-filter/",
    organizationAdminImportUrl: "users/import-organization-admin/",
    supervisorEmployeeImportUrl: "users/import-supervisor-employee/",
    userBulkDeleteSupervisorEmployeeUrl: "users/bulk-delete-supervisor-employee/",

    // User Employee Category URLs
    userEmployeeCategoryCreateUrl: "users/user-employee-category/",

    // Role URLs
    roleListUrl: "organization/list-organization-type-role/",

    // Holiday
    holidayListUrl: "reporting/holiday-report/",

    // Project Organization URLs
    projectOrganizationCreateUrl: "project/project-organization/",
    projectOrganizationListUrl: "project/project-organization/list/",
    projectOrganizationListFilterUrl: "project/project-organization/list-filter/",

    // Project Management URLs
    projectManagementCreateUrl: "project/project-management/",

    // Project Organization Service URLs
    projectOrganizationServiceCreateUrl: "project/project-organization-service/",
    projectOrganizationServiceListFilterUrl: "project/project-organization-service/list-filter/",

    // Project Zone URLs
    projectZoneCreateUrl: "project/project-zone/",
    projectZoneListFilterUrl: "project/project-zone/list-filter/",

    // Project Zone Scan Time
    projectZoneScanTimeCreateUrl: "project/project-zone-scantime/",
    projectZoneScanTimeListUrl: "project/project-zone-scantime/list/",

    // Project Zone Checklist Item URLs
    projectZoneChecklistItemCreateUrl: "project/project-zone-checklist-item/",

    // ProjectOrganizationManagement URLs
    assignedProjectOrganizationListUrl: "project/assigned-project-organization/list/",
    assignedProjectOrganizationManagementListFilterUrl: "project/assigned-project-organization-management/list-filter/",
    assignProjectOrganizationManagementUrl: "project/assign-project-organization-management/",

    // ProjectOrganizationServiceUser URLs
    assignedProjectOrganizationServiceListUrl: "project/assigned-project-organization-service/list/",
    assignedProjectOrganizationServiceUserListFilterUrl: "project/assigned-project-organization-service-user/list-filter/",
    assignProjectOrganizationServiceUserUrl: "project/assign-project-organization-service-user/",

    // Project Manager URLs
    projectManagerProjectZoneListUrl: "project/project-manager-project-zone/list/",
    projectManagerProjectZoneListMultiUrl: "project/project-manager-project-zone-multi/list/",
    projectManagerProjectZonesListMultiUrl: "project/project-manager-project-zone-service/list/",
    projectManagerProjectListFilterUrl: "project/project-manager-project/list-filter/",
    projectManagerDeleteServiceUserListFilterUrl: "project/project-manager-delete-service-user/list-filter/",
    projectManagerScanListFilterUrl: "project/project-manager-scan/list-filter/",
    projectManagerMissedScanFilterUrl: "scan/missed-scan-list-filter/",
    projectManagerScansListFilterUrl: "project/project-manager-scans/list-filter/",
    projectManagerServiceScansListFilterUrl: "project/project-manager-project-service/list/",
    projectManagerScanDetailUrl: "project/project-manager-scan-detail/",
    projectManagerTicketListFilterUrl: "project/project-manager-ticket/list-filter/",
    projectManagerTicketDetailUrl: "project/project-manager-ticket-detail/",
    projectManagerAttendanceListFilterUrl: "project/project-manager-attendance/list-filter/",
    projectManagerAllAssetMaintenanceLogsUrl: "assetservice/list-asset-maintenance-log-all-filter/",

    // Reporting URLs
    reportingScanReport: "reporting/scan-report/",
    reportingScanReportExport: "reporting/scan-report-export/",
    reportingAttendanceReport: "reporting/attendance-report/",
    reportingConsolidatedAttendanceReport: "reporting/consolidated-attendance-report/",
    dashboardOverviewUrl: "reporting/dashboard-overview/",
    scanComparisonReport: "project/project-zone-scantime-compare-list/",
    scanComparisonReportFilter: "project/project-zone-scantime-compare-list-filter/",

    //asset type
    manageAssetTypeUrl: "asset/asset-type/",
    assetTypeListFilter: "asset/list-asset-type-filter/",
    assetTypeDropdownList: "asset/list-asset-type/",

    //asset
    manageAssetUrl: "asset/",
    assetListFilter: "asset/list-filter/",
    assetDropdownList: "asset/list/",
    downloadAssetFile: "asset/download-asset-file/",

    //asset service type
    manageAssetServiceTypeUrl: "assetservice/asset-service-type/",
    assetServiceTypeListFilter: "assetservice/list-asset-service-type-filter/",
    assetServiceTypeDropdownList: "assetservice/list-asset-service-type/",

    //asset service provider
    manageAssetServiceProviderUrl: "assetservice/asset-service-provider/",
    assetServiceProviderListFilter: "assetservice/list-asset-service-provider-filter/",
    assetServiceProviderDropdownList: "assetservice/list-asset-service-provider/",

    //asset service provider contact
    manageAssetServiceProviderContactUrl: "assetservice/asset-service-provider-contact/",
    assetServiceProviderContactListFilter: "assetservice/list-asset-service-provider-contact-filter/",
    assetServiceProviderContactDropdownList: "assetservice/list-asset-service-provider-contact/",

    //asset service provider feedback
    manageAssetServiceProviderFeedbackUrl: "assetservice/asset-service-provider-feedback/",
    assetServiceProviderFeedbackListFilter: "assetservice/list-asset-service-provider-feedback-filter/",
    assetServiceProviderFeedbackDropdownList: "assetservice/list-asset-service-provider-feedback/",

    //asset maintenance log
    manageAssetMaintenanceLogUrl: "assetservice/asset-maintenance-log/",
    assetMaintenanceLogListFilter: "assetservice/list-asset-maintenance-log-filter/",
    assetMaintenanceLogDropdownList: "assetservice/list-asset-maintenance-log/",

    //asset maintenance file
    manageAssetMaintenanceFileUrl: "assetservice/asset-maintenance-file/",
    assetMaintenanceFileListFilter: "assetservice/list-asset-maintenance-file-filter/",
    assetMaintenanceFileDropdownList: "assetservice/list-asset-maintenance-file/",

    //asset maintenance notification
    manageAssetMaintenanceNotificationUrl: "assetservice/asset-notification/",
    assetMaintenanceNotificationListFilter: "assetservice/list-asset-notification-filter/",
    assetMaintenanceNotificationDropdownList: "assetservice/list-asset-notification/",

    //asset amc
    manageAssetAmcUrl: "asset/amc/",
    assetAmcListFilter: "asset/list-amc-filter/",
    assetAmcDropdownList: "asset/list-amc/",

    //amc
    amcListFilterForProjects: "asset/list-amc-filter-for-projects/",
    groupAmcListFilterForProjects: "group/amc-dashboard/",

    //asset group
    manageAssetGroupUrl: "group/",
    assetGroupListFilter: "group/list-filter/",
    assetGroupDropdownList: "group/list/",

    //asset group amc
    manageAssetGroupAmcUrl: "group/amc/",
    assetGroupAmcListFilter: "group/amc/list-filter/",
    assetGroupAmcDropdownList: "group/amc/list/",

    //asset group maintenance log
    manageAssetGroupMaintenanceLogUrl: "group/maintenance-log/",
    assetGroupMaintenanceLogListFilter: "group/maintenance-log/list-filter/",
    assetGroupMaintenanceLogDropdownList: "group/maintenance-log/list/",

    //dlp
    dlpListFilter: "asset/list-dlp-filter/",

    //project maintenance report
    projectMaintenanceReportListFilter: "asset/maintenance-report-list-filter/",
    projectMaintenanceManageReport: "asset/maintenance-report/",
    projectMaintenanceReportStatus: "asset/maintenance-report-update/",

    // scan positive response
    scanReportListFilter: "reporting/boolean-response-list-filter/",

    // scan free response
    scanFreeResponseListFilter: "reporting/free-response-list-filter/",

    // asset file import
    assetFileImport: "asset/import/",

    // Supervisor presence (geo-fence) URLs
    presenceConfigUrl: "supervisorpresence/presence-config/",
    presenceConfigDetailUrl: "supervisorpresence/presence-config/",
    presenceReportUrl: "supervisorpresence/presence-report/",

    // Supervisor -> staff mapping URLs
    presenceMappingUrl: "supervisorpresence/mapping/",
    presenceMappingListUrl: "supervisorpresence/mapping/list/",
    presenceMappingDeleteUrl: "supervisorpresence/mapping/",
    presenceMappingImportUrl: "supervisorpresence/mapping/import/",
    presenceMappingCandidatesUrl: "supervisorpresence/mapping/candidates/",

    // Minimum notification interval (in minutes) enforced by the presence scheduler
    presenceMinimumIntervalMinutes: 5,

    // Route-Based Configuration URLs (IBMS-007 to IBMS-016)
    routeConfigOverviewUrl: "project/route-config/",
    routeUrl: "project/route/",
    railwayRouteUrl: "project/route/",
    stationCoordinateValidateUrl: "project/station-coordinate-validate/",
    movingUnitUrl: "project/moving-unit/",
    railwayMovingUnitUrl: "project/moving-unit/",
    unitRouteMappingUrl: "project/unit-route-mapping/",
    scheduledTripUrl: "project/scheduled-trip/",
    movingUnitZoneUrl: "project/moving-unit-zone/",
    movingUnitZoneListFilterUrl: "project/moving-unit-zone/list-filter/"
};

/* Verification mode options for a project */
export const getVerificationModeOptions = () => {
    return [
        { label: "QR", value: "QR" },
        { label: "Geo-Fence", value: "GEO-FENCE" },
        { label: "Route-Based", value: "ROUTE-BASED" }
    ];
};

/* Route direction options */
export const getRouteDirectionOptions = () => {
    return [
        { label: "UP / Forward (Start Station/Stop → End Station/Stop)", value: "UP" },
        { label: "DOWN / Return (End Station/Stop → Start Station/Stop)", value: "DOWN" },
        { label: "Bidirectional (Both Directions)", value: "BOTH" }
    ];
};

/* Moving unit type options */
export const getMovingUnitTypeOptions = () => {
    return [
        { label: "Vehicle / Unit", value: "VEHICLE" },
        { label: "Train", value: "TRAIN" },
        { label: "Bus", value: "BUS" },
        { label: "Rake", value: "RAKE" },
        { label: "Coach Set", value: "COACH_SET" },
        { label: "Aircraft", value: "AIRCRAFT" },
        { label: "Vessel / Ship", value: "VESSEL" },
        { label: "Other / Vehicle", value: "OTHER" }
    ];
};

/* Submission status filter options for the presence report */
export const getPresenceSubmissionStatusOptions = () => {
    return [
        { label: "Submissions & Missed", value: "" },
        { label: "Submitted", value: "submitted" },
        { label: "Missed", value: "missed" }
    ];
};

/* Geo-fence status filter options for the presence report */
export const getPresenceGeofenceStatusOptions = () => {
    return [
        { label: "Inside & Outside", value: "" },
        { label: "Inside", value: "inside" },
        { label: "Outside", value: "outside" }
    ];
};

export const ErrorMessages = {
    /* Generic messages */
    required: "This field can not be blank.",
    maxLength: "This value must be no more than ",
    minLength: "This value must be no less than ",
    invalid: "This value appears to be invalid.",
    invalidDate: "This value is not a valid date.",
    invalidTime: "This value is not a valid time.",
    invalidLocation: "Please select a location from the drop-down list of options.",
    fileRequired: "You must select a file to upload.",
    reportingDateRangeNotSelected: "You must select a date range to run this report.",
    dateRangeNotSelected: "You must select all date ranges in the filter.",
    missingRequiredFields: "Please fill in all required fields.",
    invalidNumberOfRecordsMSS: "The number of Minimum Supervisor selected is not matching.",
    invalidNumberOfRecordsMES: "The number of Minimum Employee selected is not matching.",
    minValue: "This value must be greater than or equal to ",
    maxValue: "This value must be less than or equal to ",
    invalidEmail: "Please enter a valid email address.",
    invalidPhoneNumber: "Please enter a valid phone number.",

    /* Server messages */
    serverErrorPrefix: "Server: ",
    severForbiddenError: "You do not have the necessary authorization to make this request.",
    serverNotFoundError: "This data either does not exist or you are not authorized to view it.",
    serverRequestError: "The server is not responding. Please check your internet connection or try again later.",
    serverGenericError: "Something went wrong while attempting to process your request. Please try again later."
};

export const SuccessMessages = {
    /* Generic messages */
    success: "Success!",
    successMessage: "Your request was successfully processed.",

    /* Server messages */
    serverSuccessPrefix: "Server: ",
    serverSuccessMessage: "Your request was successfully processed.",

    /* Custom messages */
    instituteCreated: "Institute created successfully.",
    instituteUpdated: "Institute updated successfully.",
    instituteDeleted: "Institute deleted successfully.",

    userCreated: "User created successfully.",
    userUpdated: "User updated successfully.",
    userDeleted: "User deleted successfully.",
    organizationAdminImportSuccess: "Organization admins imported successfully.",
    supervisorEmployeeImportSuccess: "Supervisor, employee, and driver users imported successfully.",

    // asset type
    assetTypeCreated: "Asset type created successfully.",
    assetTypeUpdated: "Asset type updated successfully.",
    assetTypeDeleted: "Asset type deleted successfully.",

    // asset make
    assetMakeCreated: "Asset make created successfully.",
    assetMakeUpdated: "Asset make updated successfully.",
    assetMakeDeleted: "Asset make deleted successfully.",

    // asset
    assetCreated: "Asset created successfully.",
    assetUpdated: "Asset updated successfully.",
    assetDeleted: "Asset deleted successfully.",

    // asset service type
    assetServiceTypeCreated: "Asset service type created successfully.",
    assetServiceTypeUpdated: "Asset service type updated successfully.",
    assetServiceTypeDeleted: "Asset service type deleted successfully.",

    // asset service provider
    assetServiceProviderCreated: "Asset service provider created successfully.",
    assetServiceProviderUpdated: "Asset service provider updated successfully.",
    assetServiceProviderDeleted: "Asset service provider deleted successfully.",

    // asset service provider contact
    assetServiceProviderContactCreated: "Asset service provider contact created successfully.",
    assetServiceProviderContactUpdated: "Asset service provider contact updated successfully.",
    assetServiceProviderContactDeleted: "Asset service provider contact deleted successfully.",

    // asset service provider feedback
    assetServiceProviderFeedbackCreated: "Asset service provider feedback created successfully.",
    assetServiceProviderFeedbackUpdated: "Asset service provider feedback updated successfully.",
    assetServiceProviderFeedbackDeleted: "Asset service provider feedback deleted successfully.",

    // asset maintenance log
    assetMaintenanceLogCreated: "Asset maintenance log created successfully.",
    assetMaintenanceLogUpdated: "Asset maintenance log updated successfully.",
    assetMaintenanceLogDeleted: "Asset maintenance log deleted successfully.",

    // asset maintenance file
    assetMaintenanceFileCreated: "Asset maintenance file created successfully.",
    assetMaintenanceFileUpdated: "Asset maintenance file updated successfully.",
    assetMaintenanceFileDeleted: "Asset maintenance file deleted successfully.",

    // asset maintenance notification
    assetMaintenanceNotificationCreated: "Asset maintenance notification created successfully.",
    assetMaintenanceNotificationUpdated: "Asset maintenance notification updated successfully.",
    assetMaintenanceNotificationDeleted: "Asset maintenance notification deleted successfully.",

    // asset amc
    assetAmcCreated: "Asset amc created successfully.",
    assetAmcUpdated: "Asset amc updated successfully.",
    assetAmcDeleted: "Asset amc deleted successfully.",

    // asset group
    assetGroupCreated: "Asset group created successfully.",
    assetGroupUpdated: "Asset group updated successfully.",
    assetGroupDeleted: "Asset group deleted successfully.",

    // asset import file
    assetImportFile: "Asset Imported successfully",

    // supervisor presence
    presenceConfigSaved: "The supervisor presence configuration was successfully saved.",
    presenceMappingSaved: "The supervisor to staff mapping was successfully saved.",
    presenceMappingRemoved: "The supervisor to staff mapping was successfully removed.",
    presenceMappingImported: "The supervisor to staff mappings were successfully imported.",

    // route configuration
    routeCreated: "Route created successfully.",
    routeUpdated: "Route updated successfully.",
    routeDeleted: "Route deleted successfully.",

    // moving unit configuration
    movingUnitCreated: "Moving unit created successfully.",
    movingUnitUpdated: "Moving unit updated successfully.",
    movingUnitDeleted: "Moving unit deleted successfully."
};

/* Util method to convert file into base64 */
export const toBase64 = file => {
    if (file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });
    }
    return null;
};

/* Util method to download a file */
export const downloadFile = (fileToDownload, fileName) => {
    const anchorElement = document.createElement("a");
    anchorElement.href = fileToDownload;
    anchorElement.download = fileName;
    anchorElement.target = "_blank";
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
};

/* Util method to find an array intersection */
export const findArrayIntersection = (arr1, arr2) => {
    const set = new Set(arr1);
    return arr2.filter(item => set.has(item));
};

/* Util method to change the body attribute */
export const changeBodyAttribute = (attribute, value) => {
    if (document.body) document.body.setAttribute(attribute, value);
};

/* Utility method to get all current status */
export const getCurrentStatus = () => {
    return [
        {
            label: "Dispatched",
            value: "Dispatched"
        },
        {
            label: "Delivered",
            value: "Delivered"
        },
        {
            label: "In-Stock",
            value: "In-Stock"
        },
        {
            label: "In-Use",
            value: "In-Use"
        },
        {
            label: "Retired",
            value: "Retired"
        }
    ];
};

export const getBooleanOptions = () => {
    return [
        {
            label: "Yes",
            value: true
        },
        {
            label: "No",
            value: false
        }
    ];
};

export const getTimeOptions = () => {
    return [
        { label: "12:00 AM", value: "00:00:00" },
        { label: "12:30 AM", value: "00:30:00" },
        { label: "1:00 AM", value: "01:00:00" },
        { label: "1:30 AM", value: "01:30:00" },
        { label: "2:00 AM", value: "02:00:00" },
        { label: "2:30 AM", value: "02:30:00" },
        { label: "3:00 AM", value: "03:00:00" },
        { label: "3:30 AM", value: "03:30:00" },
        { label: "4:00 AM", value: "04:00:00" },
        { label: "4:30 AM", value: "04:30:00" },
        { label: "5:00 AM", value: "05:00:00" },
        { label: "5:30 AM", value: "05:30:00" },
        { label: "6:00 AM", value: "06:00:00" },
        { label: "6:30 AM", value: "06:30:00" },
        { label: "7:00 AM", value: "07:00:00" },
        { label: "7:30 AM", value: "07:30:00" },
        { label: "8:00 AM", value: "08:00:00" },
        { label: "8:30 AM", value: "08:30:00" },
        { label: "9:00 AM", value: "09:00:00" },
        { label: "9:30 AM", value: "09:30:00" },
        { label: "10:00 AM", value: "10:00:00" },
        { label: "10:30 AM", value: "10:30:00" },
        { label: "11:00 AM", value: "11:00:00" },
        { label: "11:30 AM", value: "11:30:00" },
        { label: "12:00 PM", value: "12:00:00" },
        { label: "12:30 PM", value: "12:30:00" },
        { label: "1:00 PM", value: "13:00:00" },
        { label: "1:30 PM", value: "13:30:00" },
        { label: "2:00 PM", value: "14:00:00" },
        { label: "2:30 PM", value: "14:30:00" },
        { label: "3:00 PM", value: "15:00:00" },
        { label: "3:30 PM", value: "15:30:00" },
        { label: "4:00 PM", value: "16:00:00" },
        { label: "4:30 PM", value: "16:30:00" },
        { label: "5:00 PM", value: "17:00:00" },
        { label: "5:30 PM", value: "17:30:00" },
        { label: "6:00 PM", value: "18:00:00" },
        { label: "6:30 PM", value: "18:30:00" },
        { label: "7:00 PM", value: "19:00:00" },
        { label: "7:30 PM", value: "19:30:00" },
        { label: "8:00 PM", value: "20:00:00" },
        { label: "8:30 PM", value: "20:30:00" },
        { label: "9:00 PM", value: "21:00:00" },
        { label: "9:30 PM", value: "21:30:00" },
        { label: "10:00 PM", value: "22:00:00" },
        { label: "10:30 PM", value: "22:30:00" },
        { label: "11:00 PM", value: "23:00:00" },
        { label: "11:30 PM", value: "23:30:00" }
    ];
};

export const getTimeOptions24Hour = () => {
    return [
        { label: "00:00:00", value: "00:00:00" },
        { label: "00:30:00", value: "00:30:00" },
        { label: "01:00:00", value: "01:00:00" },
        { label: "01:30:00", value: "01:30:00" },
        { label: "02:00:00", value: "02:00:00" },
        { label: "02:30:00", value: "02:30:00" },
        { label: "03:00:00", value: "03:00:00" },
        { label: "03:30:00", value: "03:30:00" },
        { label: "04:00:00", value: "04:00:00" },
        { label: "04:30:00", value: "04:30:00" },
        { label: "05:00:00", value: "05:00:00" },
        { label: "05:30:00", value: "05:30:00" },
        { label: "06:00:00", value: "06:00:00" },
        { label: "06:30:00", value: "06:30:00" },
        { label: "07:00:00", value: "07:00:00" },
        { label: "07:30:00", value: "07:30:00" },
        { label: "08:00:00", value: "08:00:00" },
        { label: "08:30:00", value: "08:30:00" },
        { label: "09:00:00", value: "09:00:00" },
        { label: "09:30:00", value: "09:30:00" },
        { label: "10:00:00", value: "10:00:00" },
        { label: "10:30:00", value: "10:30:00" },
        { label: "11:00:00", value: "11:00:00" },
        { label: "11:30:00", value: "11:30:00" },
        { label: "12:00:00", value: "12:00:00" },
        { label: "12:30:00", value: "12:30:00" },
        { label: "13:00:00", value: "13:00:00" },
        { label: "13:30:00", value: "13:30:00" },
        { label: "14:00:00", value: "14:00:00" },
        { label: "14:30:00", value: "14:30:00" },
        { label: "15:00:00", value: "15:00:00" },
        { label: "15:30:00", value: "15:30:00" },
        { label: "16:00:00", value: "16:00:00" },
        { label: "16:30:00", value: "16:30:00" },
        { label: "17:00:00", value: "17:00:00" },
        { label: "17:30:00", value: "17:30:00" },
        { label: "18:00:00", value: "18:00:00" },
        { label: "18:30:00", value: "18:30:00" },
        { label: "19:00:00", value: "19:00:00" },
        { label: "19:30:00", value: "19:30:00" },
        { label: "20:00:00", value: "20:00:00" },
        { label: "20:30:00", value: "20:30:00" },
        { label: "21:00:00", value: "21:00:00" },
        { label: "21:30:00", value: "21:30:00" },
        { label: "22:00:00", value: "22:00:00" },
        { label: "22:30:00", value: "22:30:00" },
        { label: "23:00:00", value: "23:00:00" },
        { label: "23:30:00", value: "23:30:00" }
    ];
};

/* Utility method to extract location properties from a Google maps object */
export const getLocationFromGoogleMapsObject = addressComponents => {
    const location = {
        city: "",
        state: ""
    };

    if (Array.isArray(addressComponents) && addressComponents.length > 0) {
        addressComponents.forEach((item, index) => {
            // Get city
            if (item.types.includes("locality")) {
                location.city = item.long_name;
            }
            // Get state
            if (item.types.includes("administrative_area_level_1")) {
                location.state = item.long_name;
            }
        });
    }

    return location;
};

export const createOption = label => ({
    label,
    value: label
});

/* Utility method to extract period type */
export const getPeriodType = () => {
    return [
        {
            label: "Weekly",
            value: "Weekly"
        },
        {
            label: "Fortnightly",
            value: "Fortnightly"
        },
        {
            label: "Monthly",
            value: "Monthly"
        },
        {
            label: "Quarterly",
            value: "Quarterly"
        },
        {
            label: "Half-Yearly",
            value: "Half-Yearly"
        },
        {
            label: "Yearly",
            value: "Yearly"
        }
    ];
};

/* Utility method to convert a date object into the expected YYYY-MM-DD format */
export const formatDate = date => {
    if (!date) return "";
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        return date.substring(0, 10);
    }
    let dateObject = new Date(date);
    if (isNaN(dateObject.getTime())) return "";
    let month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    let day = dateObject.getDate().toString().padStart(2, "0");
    let year = dateObject.getFullYear().toString();
    return `${year}-${month}-${day}`;
};

/* Utility method to convert a date object/string into a human readable string */
export const convertToReadableDate = date => {
    if (!date || date === "-" || date === "—") return "-";
    const str = String(date).trim();
    const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        const [, year, month, day] = match;
        const d = new Date(Number(year), Number(month) - 1, Number(day));
        return isNaN(d.getTime()) ? str : d.toDateString();
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? str : d.toDateString();
};

/* Utility method to convert a time string or datetime into a human readable 12-hour string */
export const convertToReadableTime = time => {
    if (!time || time === "-" || time === "—") return "-";
    const str = String(time).trim();
    // Match either full datetime (YYYY-MM-DD[T ]) or time string (HH:mm[:ss][.ssssss])
    const match = str.match(/(?:^\d{4}-\d{2}-\d{2}[T ])?(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?/);
    if (match) {
        let hours = parseInt(match[1], 10);
        const minutes = match[2];
        const seconds = match[3];
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12 || 12;
        return seconds ? `${hours}:${minutes}:${seconds}${ampm}` : `${hours}:${minutes}${ampm}`;
    }
    return str;
};

/*
    Utility method to format a punch time (ISO string, datetime, or HH:mm time)
    into consistent 12-hour compact lowercase format (e.g. "1:22pm", "12:41pm").
*/
export const formatPunchTime = value => {
    if (!value || value === "-" || value === "—") {
        return "-";
    }
    const str = String(value).trim();
    if (/(am|pm)$/i.test(str)) {
        return str.replace(/\s+/g, "").toLowerCase();
    }
    // If it is a full datetime string with date + time
    const dtMatch = str.match(/^\d{4}-\d{2}-\d{2}[T ](\d{1,2}):(\d{2})/);
    if (dtMatch) {
        let hours = parseInt(dtMatch[1], 10);
        const minutes = dtMatch[2];
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12 || 12;
        return `${hours}:${minutes}${ampm}`;
    }
    // Time-only string e.g. "13:22", "13:22:00", "07:15", "10:54:10.468000"
    const timeMatch = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?(?:\.\d+)?/);
    if (timeMatch) {
        let hours = parseInt(timeMatch[1], 10);
        const minutes = timeMatch[2];
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12 || 12;
        return `${hours}:${minutes}${ampm}`;
    }
    return str;
};

/*
    Utility method to convert an ISO / datetime string into a human readable
    "DD Mon YYYY, h:mm:ss am/pm" string. The backend sends naive server-local (IST) datetimes,
    so the components are parsed directly from the string to avoid unwanted timezone conversions.
*/
export const convertToReadableDateTime = value => {
    if (!value) {
        return "-";
    }

    const stringValue = String(value).trim();

    // Date-only value (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(stringValue)) {
        const [year, month, day] = stringValue.split("-");
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1] || "";
        return `${parseInt(day, 10)} ${monthName} ${year}`;
    }

    // Match standard ISO/datetime: YYYY-MM-DD[T ]HH:MM:SS
    const dtMatch = stringValue.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (dtMatch) {
        const [, year, month, day, hStr, mStr, sStr] = dtMatch;
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1] || "";
        let hours = parseInt(hStr, 10);
        const minutes = mStr;
        const seconds = sStr || "00";
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12 || 12;
        return `${parseInt(day, 10)} ${monthName} ${year}, ${hours}:${minutes}:${seconds}${ampm}`;
    }

    // Fallback Date parsing
    const dateObj = new Date(stringValue);
    if (isNaN(dateObj.getTime())) {
        return stringValue;
    }

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = dateObj.getDate();
    const month = monthNames[dateObj.getMonth()] || "";
    const year = dateObj.getFullYear();

    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12;

    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}${ampm}`;
};

/*
    Utility method to build a fully qualified media URL.
    Handles relative paths (e.g. /media/...) from Django backend by prepending
    the API origin if not already an absolute URL.
*/
export const buildMediaUrl = path => {
    if (!path) {
        return null;
    }
    const stringPath = String(path).trim();
    if (
        stringPath.startsWith("http://") ||
        stringPath.startsWith("https://") ||
        stringPath.startsWith("data:") ||
        stringPath.startsWith("blob:")
    ) {
        return stringPath;
    }
    const mediaBaseUrl = (GlobalValues.apiBaseUrl || "").replace(/\/api\/?$/, "");
    return mediaBaseUrl + (stringPath.startsWith("/") ? "" : "/") + stringPath;
};

/*
    Utility method to normalize photo metadata objects from backend responses
    (supporting IBMS-005 Before/After stages and IBMS-006 Spatial-Temporal metadata).
    Handles string URLs, objects, and legacy representations safely with fallbacks.
*/
export const normalizePhotoMetadata = (raw, parentRecord = null) => {
    if (!raw) {
        if (!parentRecord || typeof parentRecord !== "object") return null;
        raw = parentRecord;
    }
    if (typeof raw === "string") {
        const url = buildMediaUrl(raw);
        if (!parentRecord || typeof parentRecord !== "object") {
            return {
                pk: null,
                url,
                stage: null,
                latitude: null,
                longitude: null,
                location_accuracy: null,
                location_display: null,
                is_location_missing: false,
                device_capture_time: null,
                server_receive_time: null
            };
        }
        raw = { ...parentRecord, url };
    }
    if (typeof raw === "object") {
        const src = parentRecord && typeof parentRecord === "object" ? { ...parentRecord, ...raw } : raw;
        const rawUrl =
            src.url ||
            src.scan_image ||
            src.image ||
            src.file ||
            src.photograph ||
            src.sign_in_image ||
            src.sign_out_image ||
            "";
        const url = rawUrl ? buildMediaUrl(rawUrl) : null;
        let lat = src.latitude != null && src.latitude !== "" ? Number(src.latitude) : null;
        let lng = src.longitude != null && src.longitude !== "" ? Number(src.longitude) : null;
        let accuracy =
            src.location_accuracy != null && src.location_accuracy !== ""
                ? Number(src.location_accuracy)
                : null;
        const locationDisplay = src.location_display || null;

        // Fallback: parse coordinates from location_display if lat/lng are not directly provided
        if ((lat == null || isNaN(lat) || lng == null || isNaN(lng)) && locationDisplay) {
            const coordsMatch = String(locationDisplay).match(/(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)/);
            if (coordsMatch) {
                lat = parseFloat(coordsMatch[1]);
                lng = parseFloat(coordsMatch[2]);
            }
            const accMatch = String(locationDisplay).match(/[±+-]\s*(\d+\.?\d*)\s*m/i);
            if (accMatch && accuracy == null) {
                accuracy = parseFloat(accMatch[1]);
            }
        }

        // Additional fallbacks for flat sign-in / sign-out attendance fields (IBMS-006)
        if (lat == null && raw.sign_in_latitude != null && raw.sign_in_latitude !== "") lat = Number(raw.sign_in_latitude);
        if (lat == null && raw.sign_out_latitude != null && raw.sign_out_latitude !== "") lat = Number(raw.sign_out_latitude);
        if (lat == null && raw.sign_in_location?.latitude != null && raw.sign_in_location.latitude !== "") lat = Number(raw.sign_in_location.latitude);
        if (lat == null && raw.sign_out_location?.latitude != null && raw.sign_out_location.latitude !== "") lat = Number(raw.sign_out_location.latitude);

        if (lng == null && raw.sign_in_longitude != null && raw.sign_in_longitude !== "") lng = Number(raw.sign_in_longitude);
        if (lng == null && raw.sign_out_longitude != null && raw.sign_out_longitude !== "") lng = Number(raw.sign_out_longitude);
        if (lng == null && raw.sign_in_location?.longitude != null && raw.sign_in_location.longitude !== "") lng = Number(raw.sign_in_location.longitude);
        if (lng == null && raw.sign_out_location?.longitude != null && raw.sign_out_location.longitude !== "") lng = Number(raw.sign_out_location.longitude);

        if (accuracy == null && raw.sign_in_location_accuracy != null && raw.sign_in_location_accuracy !== "") accuracy = Number(raw.sign_in_location_accuracy);
        if (accuracy == null && raw.sign_out_location_accuracy != null && raw.sign_out_location_accuracy !== "") accuracy = Number(raw.sign_out_location_accuracy);
        if (accuracy == null && raw.sign_in_location?.accuracy != null && raw.sign_in_location.accuracy !== "") accuracy = Number(raw.sign_in_location.accuracy);
        if (accuracy == null && raw.sign_out_location?.accuracy != null && raw.sign_out_location.accuracy !== "") accuracy = Number(raw.sign_out_location.accuracy);

        const isLocationMissing = Boolean(
            raw.is_location_missing ||
            raw.sign_in_is_location_missing ||
            raw.sign_out_is_location_missing ||
            raw.is_sign_in_location_missing ||
            raw.is_sign_out_location_missing
        );

        const deviceCaptureTime =
            raw.device_capture_time ||
            raw.sign_in_device_capture_time ||
            raw.sign_out_device_capture_time ||
            null;

        const serverReceiveTime =
            raw.server_receive_time ||
            raw.sign_in_server_receive_time ||
            raw.sign_out_server_receive_time ||
            null;

        return {
            pk: raw.pk || null,
            url,
            stage: raw.stage || null,
            latitude: lat != null && !isNaN(lat) ? lat : null,
            longitude: lng != null && !isNaN(lng) ? lng : null,
            location_accuracy: accuracy != null && !isNaN(accuracy) ? accuracy : null,
            location_display: locationDisplay,
            is_location_missing: isLocationMissing,
            device_capture_time: deviceCaptureTime,
            server_receive_time: serverReceiveTime
        };
    }
    return null;
};

/**
    Utility method to format photo details for Excel export cells
    (IBMS-006 Spatial-Temporal metadata on photos for Attendance and Scan reports).
    Outputs photo URL, formatted local capture time, and location details (coordinates + accuracy or status).
*/
export const formatPhotoExcelDetails = (photo, label = "Photo") => {
    if (!photo || !photo.url) return "";
    const lines = [`${label}: ${photo.url}`];

    // Device Capture Time
    if (photo.device_capture_time) {
        lines.push(`Time: ${convertToReadableDateTime(photo.device_capture_time)}`);
    }

    // Available Location Details
    if (
        !photo.is_location_missing &&
        photo.latitude != null &&
        photo.longitude != null &&
        !isNaN(Number(photo.latitude)) &&
        !isNaN(Number(photo.longitude))
    ) {
        const latStr = Number(photo.latitude).toFixed(4);
        const lngStr = Number(photo.longitude).toFixed(4);
        let locStr = `Loc: ${latStr}, ${lngStr}`;
        if (photo.location_accuracy != null && !isNaN(Number(photo.location_accuracy))) {
            locStr += ` (±${Math.round(Number(photo.location_accuracy))}m)`;
        }
        if (
            photo.location_display &&
            !photo.location_display.includes(latStr) &&
            !photo.location_display.includes(Number(photo.latitude).toFixed(2))
        ) {
            locStr += ` - ${photo.location_display}`;
        }
        lines.push(locStr);
    } else if (photo.is_location_missing) {
        lines.push("Loc: Location Missing");
    } else if (photo.location_display) {
        lines.push(`Loc: ${photo.location_display}`);
    }

    return lines.join("\n");
};


